import { z } from 'zod';
export const resetPasswordSchema = z.object({
    token: z.string().min(1, 'Token is required'),
    newPassword: z.string().min(8, 'Password must be at least 8 characters'),
});
//# sourceMappingURL=reset-password.schema.js.map